import { defineAction } from '~/prix'
import { alertObject } from '../alertObject'
import alertListAction from './alertList.action.json' with { type: 'json' }
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'

export const alertExpression = expression(alertObject.shape)

const alertListDefinition = defineAction({
  ...alertListAction,
  input: z.object({
    filter: alertExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      synchronizedAt: 'Data de sincronização',
      id: 'Identificador',
      title: 'Título',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(alertObject),
    count: z.number(),
  }),
})

export default alertListDefinition
